/**
 * Created by iamso on 22.11.2021
 */

const UnitStories = function () {
    this.fresh = [];
    cleverapps.eventBus.on("unitOpened", this.onUnitOpened.bind(this), this);
};

UnitStories.prototype.destructor = function () {
    runCleaners(this);
};

UnitStories.prototype.findStory = function (key) {
    const bundle = bundles[`unitstories_${cleverapps.meta.selectedLocationId()}`];
    if (!bundle) {
        return;
    }

    const unitStories = bundle.jsons.unitstories_json.resolve().getJson();

    let story = unitStories[key];
    if (story) {
        if (key === "fog_fog4_0") {
            story = cleverapps.clone(story, true);
            story.target = { code: "wood", stage: 0 };
        }

        return story;
    }
};

UnitStories.prototype.onUnitOpened = function (unit) {
    const unitStory = this.findStory(Unit.GetKey(unit));
    if (!unitStory || !(unit instanceof Unit)) {
        return;
    }

    if (["caravanship", "kraken"].indexOf(unit.code) !== -1) {
        return;
    }

    this.fresh.push({
        story: unitStory,
        unit
    });
    Map2dLocation.currentLocation.counter.trigger();
};

UnitStories.prototype.onFogOpened = function (fogId) {
    const unitStory = this.findStory(`fog_${fogId}`);
    if (!unitStory) {
        return;
    }

    let targets;

    if (unitStory.target) {
        const units = Map2d.currentMap.listAvailableUnitsInRegion(fogId, unitStory.target);
        targets = Map2d.currentMap.findLargestGroup(units);
    }

    this.fresh.push({
        story: unitStory,
        unit: targets
    });
};

UnitStories.prototype.processFresh = function () {
    if (!this.fresh.length || cleverapps.focusManager.isFocused() || Map2d.currentMap.dragging) {
        return;
    }

    const unitStory = this.fresh.shift();

    cleverapps.focusManager.display({
        focus: "StartUnitDialogue",
        actions: [
            function (f) {
                this.showUnitStory(f, unitStory.story.dialogue, {
                    unit: unitStory.unit,
                    tutorial: this.getTutorial(unitStory.story.id),
                    guideWindow: unitStory.story.guideWindow
                });
            }.bind(this)
        ]
    });
};

UnitStories.prototype.displayFreshStory = function (unit, f) {
    const unitStoryIndex = unit ? this.fresh.findIndex((item) => item.story && item.story.id === Unit.GetKey(unit)) : -1;
    const unitStory = this.fresh[unitStoryIndex];

    if (!unitStory) {
        f();
        return;
    }

    this.fresh.splice(unitStoryIndex, 1);

    this.showUnitStory(f, unitStory.story.dialogue, {
        unit: unitStory.unit,
        tutorial: this.getTutorial(unitStory.story.id),
        guideWindow: unitStory.story.guideWindow
    });
};

UnitStories.prototype.getTutorial = function (storyId) {
    if (Map2dLocation.currentLocation) {
        return Map2dLocation.currentLocation.getMergeTutorial(`story_${storyId}`);
    }
    return undefined;
};

UnitStories.prototype.showUnitStory = function (f, dialogueData, options) {
    options = options || {};

    if (!dialogueData || cleverapps.gameModes.skipUnitStories) {
        f();
        return;
    }

    const units = cleverapps.toArray(options.unit);
    const inMapDialogues = cleverapps.meta.getSelectedLocation().locationConfig.inMapDialogues;
    const worker = Map2d.currentMap.workers && Map2d.currentMap.workers.findFree(undefined, true);
    const workerCanWalk = worker && inMapDialogues && Map2d.currentMap.workers.canWalk();

    const unit = cc.getCenterPoint(units);
    let affectedUnits;
    if (unit) {
        affectedUnits = this.findUnitsInRadius(unit.x, unit.y, 4);
    }

    let targetBlockHeight;

    cleverapps.focusManager.compound(f, [
        function (f) {
            if (unit) {
                const zoom = 1.2;
                let centerOffset;
                if (DialogueView.getCtor() === DialogueViewVertical) {
                    const styles = cleverapps.styles.DialogueViewVertical;
                    const sceneSize = cleverapps.resolution.getSceneSize();
                    const bbs = (workerCanWalk ? units.concat([worker]) : units).map((u) => {
                        const v = u.onGetView();
                        return v && v.getBoundingBoxToWorld();
                    }).filter(Boolean);
                    targetBlockHeight = bbs.length ? (Math.max(...bbs.map((bb) => bb.y + bb.height)) - Math.min(...bbs.map((bb) => bb.y))) * zoom : 0;
                    centerOffset = { x: 0, y: sceneSize.height / 2 - styles.targetBlock.margin - targetBlockHeight / 2 };
                }

                Map2dScroller.currentScroller.zoomIn(unit, {
                    zoom,
                    centerOffset,
                    callback: function () {
                        unit.outline(true);
                        affectedUnits.forEach((unit) => {
                            unit.hideAdditionalViews();
                        });
                        f();
                    }
                });
            } else {
                f();
            }
        },

        function (f) {
            let delay = 600;

            if (options.delay !== undefined) {
                delay = options.delay;
            } else if (unit && unit.onGetView()) {
                delay = 0;
            }

            Map2dLocation.currentLocation.counter.setTimeout(f, delay);
        },

        function (f) {
            if (unit) {
                unit.onDialogueStart();
                if (workerCanWalk) {
                    worker.walkNextToUnit(unit, f);
                } else {
                    f();
                }
            } else {
                f();
            }
        },

        function (f) {
            this.showDialogue(dialogueData, units, f, targetBlockHeight, worker);
        }.bind(this),

        function (f) {
            if (unit) {
                if (options.cancelZoomOut) {
                    Map2dScroller.currentScroller.cancelZoomOut();
                    f();
                } else {
                    Map2dScroller.currentScroller.zoomOut(f);
                }
            } else {
                f();
            }
        },

        function (f) {
            if (unit) {
                unit.onDialogueEnd();
            }
            f();
        },

        function (f) {
            if (unit) {
                affectedUnits.forEach((unit) => {
                    unit.showAdditionalViews();
                });
            }
            f();
        },
        function (f) {
            if (options.tutorial) {
                Map2dLocation.currentLocation.tutorial.showTutorial(options.tutorial, f);
            } else {
                f();
            }
        },
        function (f) {
            if (options.guideWindow && options.guideWindow.code && options.guideWindow.stage !== undefined) {
                let guideOptions = Families[options.guideWindow.code].units[options.guideWindow.stage].customer.guide;
                if (guideOptions[cleverapps.meta.selectedLocationId()]) {
                    guideOptions = guideOptions[cleverapps.meta.selectedLocationId()];
                }
                new GuideWindow(guideOptions);
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        }
    ]);
};

UnitStories.prototype.findUnitsInRadius = function (x, y, radius) {
    const map = Map2d.currentMap;
    const foundUnits = [];

    map.iterateBfs(x, y, (pos) => {
        if (pos.step > radius) {
            return true;
        }

        const foundUnit = map.getUnit(pos.x, pos.y);
        if (!foundUnit) {
            return;
        }

        foundUnits.push(foundUnit);
    });

    return foundUnits;
};

UnitStories.prototype.showDialogue = function (dialogueData, units, f, targetBlockHeight, worker) {
    const steps = cleverapps.clone(dialogueData, true);
    const highlighters = [];

    const dialogue = new Dialogue(steps, {
        showUp: true,
        autoClose: true,
        autoScroll: false,
        targetBlockHeight,
        imageBundle: (bundles.dialogues_images || bundles.dialogues || {}).name
    });

    const inMapDialogues = cleverapps.meta.getSelectedLocation().locationConfig.inMapDialogues;

    dialogue.on("afterClose", f);

    dialogue.on("beforeClose", () => {
        highlighters.forEach((highlighter) => {
            highlighter.unhighlight();
        });
        if (inMapDialogues && worker) {
            worker.unhighlight && worker.unhighlight();
        }
    });

    dialogue.on("contentChanged", () => {
        if (!units) {
            return;
        }

        highlighters.forEach((highlighter) => {
            highlighter.unhighlight();
        });

        units = units.filter((unit) => unit.onGetView());
        units.sort((a, b) => (b.x - a.x) || (a.y - b.y));

        const unique = units.reduce((arr, unit) => {
            if (!arr.find((item) => Unit.IsApplicable(item, unit))) {
                arr.push(unit);
            }
            return arr;
        }, []);

        units.forEach((unit) => {
            const spotlight = units.length === 1 || (unique.length > 1 && unique.includes(unit));
            const ground = cleverapps.meta.selectedLocationId() === "main" || cleverapps.skins.getSlot("unitGroundHighlight");
            const highlighter = new UnitHighlighter(Map2d.currentMap.getMapView(), unit, { spotlight, ground });
            highlighters.push(highlighter);
        });

        if (inMapDialogues && worker) {
            worker.highlight && worker.highlight();
        }
    });

    const dialogueView = new DialogueView(dialogue);
    dialogueView._setGlobalZOrder(true);
};
